import React from 'react';
import T from 'prop-types';
import classnames from 'classnames';

import Zoom from './zoom';
import * as Classes from './styles.module.scss';

import { FLOAT_DECKLED, FLOAT_STRIGHT } from '../PapersMenu/mounts';

const PaperView = ({
  width, height, borderH, borderW, backgroundImage, unframed,
  frameThicknessH, frameThicknessV, zoomPreviewUrl,
  mount, isTapestry, frameMatColorRgb,
  children
}) => {
  const styles = { flexBasis: width, height };
  if (backgroundImage) {
    styles.backgroundImage = `url(${ backgroundImage })`;
  }
  const innerStyle = {
    paddingTop: `${ borderH }%`,
    paddingBottom: `${ borderH }%`,
    paddingLeft: `${ borderW }%`,
    paddingRight: `${ borderW }%`
  };

  const paperClass = unframed ? Classes.externalShadow : '';
  const frameClass = backgroundImage ? Classes.externalShadow : '';

  let frameShadow = null;
  let imageClassName = null;
  const isFloat = FLOAT_DECKLED === mount || FLOAT_STRIGHT === mount;
  if (frameThicknessH && !isFloat && !isTapestry) {
    const frameShadowStyle = {
      top: `${ frameThicknessV }%`,
      right: `${ frameThicknessH }%`,
      bottom: `${ frameThicknessV }%`,
      left: `${ frameThicknessH }%`
    };
    if (frameMatColorRgb) {
      frameShadowStyle.backgroundColor = `rgb(${ frameMatColorRgb.join(',') })`;
      imageClassName = Classes.workImageFramed;
    }
    frameShadow = <div className={ Classes.frameShadow } style={ frameShadowStyle } />;
  }

  return (
    <Zoom
      style={ styles }
      className={ classnames(Classes.paper, frameClass) }
      zoomPreviewUrl={ zoomPreviewUrl }
    >
      <div style={ innerStyle } className={ paperClass }>
        { frameShadow }
        { children({ className: imageClassName }) }
      </div>
    </Zoom>
  );
};

PaperView.propTypes = {
  width: T.string,
  height: T.string,
  borderH: T.number,
  borderW: T.number,
  backgroundImage: T.string,
  zoomPreviewUrl: T.string,
  landscape: T.bool,
  unframed: T.bool.isRequired,
  frameThicknessV: T.number,
  frameThicknessH: T.number,
  mount: T.string,
  isTapestry: T.bool,
  frameMatColorRgb: T.array,
  children: T.func.isRequired
};

export default  PaperView;
